import { GetTemporaryTransactionDTO, CartTotalQuantityDTO, CartTotalPriceDTO} from '@signature-it/ngx-catalogue/models';
import { CodescDTO } from '@signature-it/ngx-generic/models';
import { ICartStateGeneric } from '@signature-it/ngx-catalogue/store/interfaces';

export class CartStateModelGeneric implements ICartStateGeneric {
	cart: GetTemporaryTransactionDTO;
	cartProductIds: Array<number>;
	itemsQuantity: CartTotalQuantityDTO;
	totalPrice: CartTotalPriceDTO;
    totalPriceError: string;
    shippingMethods: CodescDTO[];
	processingGetCart: boolean;
	processingAddToCart: boolean;
	loadingUpdatedCart: boolean;
	loadingTotalPrice: boolean;
	loadingTotalQuantity: boolean;
	processingCheckout: boolean;
	processingCheckoutCG: boolean;
	processingCheckoutPCC: boolean;
	processingCheckoutPFT: boolean;
	updateAllQuantities: boolean;
	addToCartOpenModal: boolean;
    redirectLink: boolean;
    addToCartAfterRemove: boolean;
    addToCartError: string;
    checkoutError: string;
    updatedCartSuccess: boolean;
    skipModalAfterAddToCart: boolean;
    loadingShippingMethods: boolean;
    removeAllItemsError: string;

	constructor(attributes?: object) {
		attributes = attributes || {};

		this.cart = attributes['cart'] ? GetTemporaryTransactionDTO.create(attributes['cart']) : null;
		this.cartProductIds = attributes['cartProductIds'] ? attributes['cartProductIds'] : [];
		this.itemsQuantity = attributes['itemsQuantity'] ? CartTotalQuantityDTO.create(attributes['itemsQuantity']): CartTotalQuantityDTO.create({total_quantity: 0});
		this.totalPrice = attributes['totalPrice'] ? CartTotalPriceDTO.create(attributes['totalPrice']) : null;
        this.totalPriceError = attributes['totalPriceError'] || '';
        this.shippingMethods = attributes['shippingMethods'];
        this.processingGetCart = attributes['processingAddToCart'] || false;
		this.processingAddToCart = attributes['processingAddToCart'] || false;
		this.loadingUpdatedCart = attributes['loadingUpdatedCart'] || false;
		this.loadingTotalPrice = attributes['loadingTotalPrice'] || false;
		this.loadingTotalQuantity = attributes['loadingTotalQuantity'] || false;
		this.processingCheckout = attributes['processingCheckout'] || false;
		this.processingCheckoutCG = attributes['processingCheckoutCG'] || false;
		this.processingCheckoutPCC = attributes['processingCheckoutPCC'] || false;
		this.processingCheckoutPFT = attributes['processingCheckoutPFT'] || false;
		this.updateAllQuantities = attributes['updateAllQuantities'] || false;
		this.addToCartOpenModal = attributes['addToCartOpenModal'] || false;
		this.redirectLink = attributes['redirectLink'] || false;
		this.addToCartAfterRemove = attributes['addToCartAfterRemove'] || false;
		this.addToCartError = attributes['addToCartError'] || '';
		this.checkoutError = attributes['checkoutError'] || '';
		this.updatedCartSuccess = attributes['updatedCartSuccess'] || false;
		this.skipModalAfterAddToCart = attributes['skipModalAfterAddToCart'] || false;
        this.loadingShippingMethods = attributes['loadingShippingMethods'] || false;
        this.removeAllItemsError = attributes['removeAllItemsError'] || '';
	}
}
